import { render, staticRenderFns } from "./DeliveryCampaignGroupsCreatePage.vue?vue&type=template&id=7f892d15&scoped=true"
import script from "./DeliveryCampaignGroupsCreatePage.vue?vue&type=script&lang=js"
export * from "./DeliveryCampaignGroupsCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f892d15",
  null
  
)

export default component.exports